import React from "react";

/**
 * "Développé par DKCONNECT" branding footer, avec logo officiel.
 * Variants:
 *  - "app"    : subtle footer inside authenticated app layout (light bg)
 *  - "dark"   : white-on-dark for hero/screens (borne, écran)
 *  - "compact": inline centered small variant
 */
const LOGO_SRC = "/dkconnect-logo.png";

export default function DKFooter({ variant = "app" }) {
  if (variant === "dark") {
    return (
      <div
        className="flex items-center justify-center gap-2 py-3"
        data-testid="dk-footer"
      >
        <span className="text-[11px] text-blue-200/70 tracking-[0.24em] uppercase">
          Logiciel développé par
        </span>
        <img
          src={LOGO_SRC}
          alt="DKCONNECT — Connecter, simplifier, accompagner"
          className="h-8 w-auto object-contain opacity-90"
          style={{ filter: "brightness(1.2) contrast(1.05)" }}
        />
      </div>
    );
  }

  if (variant === "compact") {
    return (
      <div
        className="flex items-center justify-center gap-2 py-2"
        data-testid="dk-footer"
      >
        <span className="text-[11px] text-slate-400 tracking-[0.22em] uppercase">
          Développé par
        </span>
        <img
          src={LOGO_SRC}
          alt="DKCONNECT"
          className="h-6 w-auto object-contain"
        />
      </div>
    );
  }

  // app (default)
  return (
    <footer
      className="border-t border-slate-200 dark:border-slate-800 bg-white/60 dark:bg-slate-900/60 backdrop-blur-sm py-3 px-6"
      data-testid="dk-footer"
    >
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <span className="text-[11px] text-slate-500 dark:text-slate-400 tracking-[0.22em] uppercase">
          Logiciel développé par
        </span>
        <img
          src={LOGO_SRC}
          alt="DKCONNECT — Connecter, simplifier, accompagner"
          className="h-7 w-auto object-contain"
        />
        <span className="text-slate-300 dark:text-slate-600">·</span>
        <span className="text-[11px] text-slate-400 dark:text-slate-500 normal-case tracking-normal">
          © {new Date().getFullYear()} — Tous droits réservés
        </span>
      </div>
    </footer>
  );
}
